import { render, staticRenderFns } from "./PointSecuritymoneyForm.vue?vue&type=template&id=152ae5f0"
import script from "./PointSecuritymoneyForm.vue?vue&type=script&lang=js"
export * from "./PointSecuritymoneyForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports